import { render, staticRenderFns } from "./UserDeletionWidget.vue?vue&type=template&id=3c857100&scoped=true"
import script from "./UserDeletionWidget.vue?vue&type=script&lang=js"
export * from "./UserDeletionWidget.vue?vue&type=script&lang=js"
import style0 from "./UserDeletionWidget.vue?vue&type=style&index=0&id=3c857100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c857100",
  null
  
)

export default component.exports